import { useMutation } from "react-query";
import { sendSingleAttributeData } from "components/attributes/lib/attribute-data";

export const useSendToGdsn = () => {
    // bellow id is hardcoded UUID for SendToGDSN attribute
    return useMutation(({ sendToGdsn, wipKey, taskKey }) => {
        return sendSingleAttributeData(wipKey, taskKey, "leftrail", { definition: "8091042086029806968", value: sendToGdsn });
    });
};
